/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Heatmap': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 .25C4.616.25.25 4.616.25 10s4.366 9.75 9.75 9.75c.9 0 1.625-.726 1.625-1.625 0-.422-.162-.802-.422-1.094a1.627 1.627 0 01-.412-1.073c0-.899.726-1.625 1.625-1.625h1.917a5.419 5.419 0 005.417-5.416C19.75 4.128 15.384.25 10 .25zM4.042 10c-.9 0-1.625-.726-1.625-1.625 0-.9.726-1.625 1.625-1.625s1.625.726 1.625 1.625c0 .9-.726 1.625-1.625 1.625zm3.25-4.333c-.9 0-1.625-.726-1.625-1.625 0-.9.726-1.625 1.625-1.625s1.625.726 1.625 1.625-.726 1.625-1.625 1.625zm5.416 0c-.899 0-1.625-.726-1.625-1.625 0-.9.726-1.625 1.625-1.625.9 0 1.625.726 1.625 1.625s-.726 1.625-1.625 1.625zM15.958 10c-.899 0-1.625-.726-1.625-1.625 0-.9.726-1.625 1.625-1.625.9 0 1.625.726 1.625 1.625 0 .9-.725 1.625-1.625 1.625z" _fill="#00204D"/>'
  }
})
